const features = [
  {
    icon: 'ri-database-2-line',
    title: '海量片库每日更新',
    desc: '12000+影视资源持续扩充，每日更新50+部热门电影、电视剧和综艺节目，追剧党永远不剧荒。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '高清流畅不缓冲',
    desc: '全站支持1080P高清画质，采用智能CDN加速技术，打开即播无需等待，观影体验丝滑流畅。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步随时看',
    desc: '手机、平板、电脑全端适配，支持APP下载离线缓存，随时随地追剧看电影不受限制。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            平台优势
          </h2>
          <p className="mt-3 text-sm text-foreground-500">为什么千万用户选择7777影院</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-6 md:p-8 text-center flex flex-col items-center"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-primary-50 flex items-center justify-center mb-5">
                <i className={`${item.icon} text-2xl md:text-3xl text-primary-600 w-8 h-8 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}